module.exports = __webpack_public_path__ + "static/img/1771.0696255.png";